<template>
  <div class="chartScale">
    <el-button
      :type="index === chartScaleItems.active ? 'primary' : ''"
      size="mini"
      round
      v-for="(item, index) in chartScaleItems.items"
      @click="setScale(index)"
      :key="index">{{item.title}}
    </el-button>
  </div>
</template>
<script>
  export default {
    name: "ChartScale",
    props: {
      chartScaleItems: {
        type: Object
      }
    },
    methods: {
      setScale(idx){
        this.$emit('setScale', idx);
      }
    }
  };
</script>

<style>
  .chartScale {
    margin-bottom: 25px;
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
  }
</style>
